import { format } from 'date-fns'
import { enUS } from "date-fns/locale";

// Format date for display using user's local timezone
export const formatTimeCreated = (date?: Date): string => {
  if (!date) return '-'
  try {
    return format(date, 'MMM d, h:mm a')
  } catch {
    return '-'
  }
};

export const formatDate = (date: Date) => {
  return format(date, 'MMM d, yyyy h:mm a', {
    locale: enUS,
  });
};

/* Check calls_platform/app/utils/strings.tsx formatISODate */
export function formatISODate(date: Date | string | undefined | null): string {
  if (!date) return '-'
  const d = typeof date === 'string' ? new Date(date) : date;
  return format(d, 'MMM d, yyyy h:mm a');
}

// Format timestamp
export function formatTimestamp(timestamp: number | null): string {
  if (!timestamp) return '-'
  return format(new Date(timestamp * 1000), 'MMM d, HH:mm')
}

export function formatTimestampYear(timestamp: number): string {
  if (!timestamp) return '-'
  return format(new Date(timestamp * 1000), 'MMM d, yyyy h:mm a')
}

// Format duration in mm:ss check calls_platform/app/utils/strings.tsx formatDurationValue
export function formatDuration(seconds: number | null): string {
  if (seconds === null || seconds === undefined) return '-'
  const mins = Math.floor(seconds / 60)
  const secs = Math.floor(seconds % 60)
  return `${mins}:${secs.toString().padStart(2, '0')}`
}

// Format date for display
export function formatDateHistory(date: Date, formatStr: string): string {
  return format(date, formatStr)
}